import api from '../api'
import {extractValidationErrors} from '../../../../helpers/api'

import {
    CHANGE_PROGRESS,
    DELETE_SERVICE,
    INIT_SERVICE_FORM_CONTEXT,
    RESET_SERVICE_FORM_VALIDATION_ERRORS_BY_FIELD,
    SET_SERVICE_FORM_VALIDATION_ERRORS,
    UPDATE_SERVICE,
    UPDATE_SERVICES,
    CHANGE_SERVICE_FORM_FIELD,
    CHANGE_SERVICE_FORM_VALIDATION
} from '../mutations/available'

import _ from 'lodash'
import NotificationService from '../../../../services/notificationService'

export const initCreateServiceFormData = async ({state, dispatch, commit}) => {
    dispatch('resetServiceFormData')
}

export const initUpdateServiceFormData = async ({state, dispatch, commit}, serviceId) => {
    let service = _.get(state.services, serviceId, null)

    if (service === null) {
        try {
            service = await api.getService(serviceId)
        } catch (e) {
            NotificationService.error(`Unable to get service. Try again later`)
            return
        }
    }

    commit(INIT_SERVICE_FORM_CONTEXT, {
        context: 'update',
        data: service,
        formValid: true
    })
}

export const resetServiceFormData = async ({state, dispatch, commit}) => {
    commit(INIT_SERVICE_FORM_CONTEXT, {
        context: 'create',
        data: {
            code: '',
            title: '',
            price: 0.0,
            currency: 'rub'
        }
    })
}


export const changeServiceFormField = async ({state, dispatch, commit}, {context, name, value}) => {
    commit(CHANGE_SERVICE_FORM_FIELD, {
        context: context,
        name: name,
        value: value
    })
}

export const changeServiceFormValidation = async ({state, dispatch, commit}, {context, value}) => {
    commit(CHANGE_SERVICE_FORM_VALIDATION, {
        context: context,
        value: value
    })
}

export const getAll = async ({state, dispatch, commit}) => {
    if (state.progress['getAllServices']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getAllServices', value: true})

    try {
        const clientsData = await api.getAll()
        commit(UPDATE_SERVICES, clientsData)
    } catch (e) {
        NotificationService.error(`Unable to get services. Try again later`)
        console.log(`Unable to get clients, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'getAllServices', value: false})
}

export const createService = async ({state, dispatch, commit}) => {
    if (state.progress['createService']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'createService', value: true})
    commit(SET_SERVICE_FORM_VALIDATION_ERRORS, {
        context: 'create',
        value: {}
    })

    let serviceData = _.cloneDeep(_.get(state, ['serviceFormContexts', 'create', 'data']))
    serviceData.price = parseFloat(serviceData.price)

    let created = false
    try {
        await api.createService(serviceData)
        NotificationService.success(`Service '${serviceData.title} was successfully created'`)
        created = true
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_SERVICE_FORM_VALIDATION_ERRORS, {
                context: 'create',
                value: validationErrors
            })
        } else {
            NotificationService.error(`Unable to create service. Try again later`)
        }
    }

    commit(CHANGE_PROGRESS, {context: 'createService', value: false})

    return created
}

export const updateService = async ({state, dispatch, commit}) => {
    if (state.progress['updateService']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'updateService', value: true})
    commit(SET_SERVICE_FORM_VALIDATION_ERRORS, {
        context: 'update',
        value: {}
    })

    let serviceData = _.cloneDeep(_.get(state, ['serviceFormContexts', 'update', 'data']))
    serviceData.price = parseFloat(serviceData.price)

    let updated = false
    try {
        const updatedService = await api.updateService(serviceData)
        commit(UPDATE_SERVICE, updatedService)
        updated = true
        NotificationService.success(`Service '${serviceData.title}' was successfully updated`)
    } catch (e) {
        const validationErrors = extractValidationErrors(e)

        if (validationErrors) {
            commit(SET_SERVICE_FORM_VALIDATION_ERRORS, {
                context: 'update',
                value: validationErrors
            })
        } else {
            NotificationService.error(`Unable to update service '${serviceData.title}'. Try again later`)
        }
        console.log(`Unable to update service, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'updateService', value: false})

    return updated
}

export const deleteService = async ({state, dispatch, commit}, serviceData) => {
    if (state.progress['deleteService']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'deleteService', value: true})

    try {
        await api.deleteService(serviceData.id)
        commit(DELETE_SERVICE, serviceData)
        NotificationService.success(`Service '${serviceData.title}' was successfully deleted`)
    } catch (e) {
        console.log(e)
        NotificationService.error(`Unable to delete service '${serviceData.title}'. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'deleteService', value: false})
}

export const resetServiceFormValidationErrorsByField = async ({state, commit}, {context, fieldName}) => {
    commit(RESET_SERVICE_FORM_VALIDATION_ERRORS_BY_FIELD, {context, fieldName})
}

export const afterApplicationInit = {
    root: true,
    async handler(namespacedContext, payload) {
        const services = _.get(payload, 'services', [])
        namespacedContext.commit(UPDATE_SERVICES, services)
    }

}

